export const overwriteDefaults = {
  organization : {
    // Overwrite default errors
    httpHandlers : {
      conflict : {
        unit : 'User already exists.'
      }
    }
  }
};
